/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationNotificationsScheduledNotificationItem } from './FxIdApplicationNotificationsScheduledNotificationItem';
import {
    FxIdApplicationNotificationsScheduledNotificationItemFromJSON,
    FxIdApplicationNotificationsScheduledNotificationItemFromJSONTyped,
    FxIdApplicationNotificationsScheduledNotificationItemToJSON,
    FxIdApplicationNotificationsScheduledNotificationItemToJSONTyped,
} from './FxIdApplicationNotificationsScheduledNotificationItem';

/**
 * Аргументы для шедулинга нотификаций (append, не заменяет существующие)
 * @export
 * @interface FxIdApplicationNotificationsScheduleScheduleNotificationsArgs
 */
export interface FxIdApplicationNotificationsScheduleScheduleNotificationsArgs {
    /**
     * Игра, от имени которой шедулятся уведомления
     * @type {string}
     * @memberof FxIdApplicationNotificationsScheduleScheduleNotificationsArgs
     */
    Game: string;
    /**
     * Список уведомлений для постановки в очередь
     * @type {Array<FxIdApplicationNotificationsScheduledNotificationItem>}
     * @memberof FxIdApplicationNotificationsScheduleScheduleNotificationsArgs
     */
    Notifications: Array<FxIdApplicationNotificationsScheduledNotificationItem>;
}

/**
 * Check if a given object implements the FxIdApplicationNotificationsScheduleScheduleNotificationsArgs interface.
 */
export function instanceOfFxIdApplicationNotificationsScheduleScheduleNotificationsArgs(value: object): value is FxIdApplicationNotificationsScheduleScheduleNotificationsArgs {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('Notifications' in value) || value['Notifications'] === undefined) return false;
    return true;
}

export function FxIdApplicationNotificationsScheduleScheduleNotificationsArgsFromJSON(json: any): FxIdApplicationNotificationsScheduleScheduleNotificationsArgs {
    return FxIdApplicationNotificationsScheduleScheduleNotificationsArgsFromJSONTyped(json, false);
}

export function FxIdApplicationNotificationsScheduleScheduleNotificationsArgsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationNotificationsScheduleScheduleNotificationsArgs {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'Notifications': ((json['Notifications'] as Array<any>).map(FxIdApplicationNotificationsScheduledNotificationItemFromJSON)),
    };
}

export function FxIdApplicationNotificationsScheduleScheduleNotificationsArgsToJSON(json: any): FxIdApplicationNotificationsScheduleScheduleNotificationsArgs {
    return FxIdApplicationNotificationsScheduleScheduleNotificationsArgsToJSONTyped(json, false);
}

export function FxIdApplicationNotificationsScheduleScheduleNotificationsArgsToJSONTyped(value?: FxIdApplicationNotificationsScheduleScheduleNotificationsArgs | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'Notifications': ((value['Notifications'] as Array<any>).map(FxIdApplicationNotificationsScheduledNotificationItemToJSON)),
    };
}

